import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ContenedorComponent } from '../contenedor/contenedor.component';
import { ConcentracionComponent } from '../riesgo-liquidez/concentracion/concentracion.component';
import { authGuardSubmodule } from '../../auth/auth.guard';
import { MayoresDepositantesComponent } from '../riesgo-liquidez/mayores-depositantes/mayores-depositantes.component';
import { GapComponent } from './gap/gap.component';
import { CoberturaRCLComponent } from './cobertura-rcl/cobertura-rcl.component';
import { GapAiracComponent } from './gap-airac/gap-airac.component';
import { RazonesLiquidezComponent } from './razones-liquidez/razones-liquidez.component';
import { CalcesPlazosComponent } from './calces-plazos/calces-plazos.component';
import { VolatilidadComponent } from './volatilidad/volatilidad.component';

const routes: Routes = [
  {
 path: 'app/riesgo-liquidez',
       component: ContenedorComponent,
      children: [
        {path: 'gap', component: GapComponent, canActivate: [authGuardSubmodule]},
        {path: 'gap-airac', component: GapAiracComponent, canActivate: [authGuardSubmodule]},
        {path: 'razones-liquidez', component: RazonesLiquidezComponent, canActivate: [authGuardSubmodule]},
        {path: 'volatilidad', component: VolatilidadComponent, canActivate: [authGuardSubmodule]},
        {path: 'concentracion', component: ConcentracionComponent, canActivate: [authGuardSubmodule]},
        {path: 'mayores-depositantes', component: MayoresDepositantesComponent, canActivate: [authGuardSubmodule]},
        {path: 'cobertura', component: CoberturaRCLComponent, canActivate: [authGuardSubmodule]},
        {path: 'calces-plazos', component: CalcesPlazosComponent, canActivate: [authGuardSubmodule]},
      ],
    }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class RiesgoLiquidezRoutingModule { }
